export enum Regions {
    QLD = 11, 
    NSW = 12,
    VIC = 13,
    ACT = 14,
    WA = 15,
    SA = 16,
    TAS = 17,
    NT = 18,
    RestOfWorld = 8
}

export const regions: Record<string, number> = {
    'QLD': 11,
    'NSW': 12,
    'VIC': 13,
    'ACT': 14,
    'WA': 15,
    'SA': 16,
    'TAS': 17,
    'NT': 18,
    'Rest of World': 8,
};
